import { render, staticRenderFns } from "./CelebrityList2.vue?vue&type=template&id=4c2ddff4&scoped=true&"
import script from "./CelebrityList2.vue?vue&type=script&lang=js&"
export * from "./CelebrityList2.vue?vue&type=script&lang=js&"
import style0 from "./CelebrityList2.vue?vue&type=style&index=0&id=4c2ddff4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2ddff4",
  null
  
)

export default component.exports